/**
 * requiredIf is a method that should be used each
 * time a component wants to make a prop required based on a special
 * condition.
 *
 * This method will be ignored in production code.
 *
 * @param  {Function} propType    Any valid PropType (e.g. PropTypes.bool)
 * @param  {Function} condition   A function that returns `true` or `false`
 * @param  {String} explanation   Explanation for the consumer.
 * @return {Exception}            Return new Error if prop is passed.
 */
export default function requiredIf(propType, condition, explanation, customPropName) {
  return function (props, propName, componentName) {
    if (condition(props, propName)) {
      return new Error(`The prop \`${customPropName || propName}\` is required in \`${componentName}\` ${explanation}`);
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType(props, propName, componentName, ...rest);
  };
}